import { H2, Image, Section } from '@ahmdigital/ui';
import { isNil } from 'lodash/fp';
import { useSelector } from 'react-redux';
// @ts-expect-error - Automatic, Please fix when editing this file
import getAllRewards from '@ahmdigital/offers/lib/model/offer/get-all-rewards';

import filterOffersByProductType from '../../../../utils/filter-offers-by-product-type';
import getContentForOffer from '../../../../components/offers/tile/utils/get-content-for-offer';
import OfferHeading from '../../../../components/offers/tile/components/offer-heading';
import offerTagImage from '../../../../components/offers/images/offer-tag.svg';
import ProductPropType from '../../../../types/product';
import RewardsList from './components/rewards-list';
import selectReferralCode from '../../../../selectors/select-referral-code';
import useShouldShowOfferBanner from '../../../../components/offers/banner/use-should-show-offer-banner';
import type { Offer, Placeholder } from '../../../../components/offers/types';

type HeroOfferSectionProps = {
  activeOffers?: Offer[];
  lastViewedProduct?: ProductPropType;
  placeholders?: Placeholder[];
};

const HeroOfferSection = ({ activeOffers, lastViewedProduct, placeholders }: HeroOfferSectionProps) => {
  const referralCode = useSelector(selectReferralCode);
  const shouldShow = useShouldShowOfferBanner({ activeOffers });

  const lastViewedProductType = lastViewedProduct?.type;
  const offer = filterOffersByProductType(lastViewedProductType, activeOffers ?? []);

  if (!shouldShow || !isNil(referralCode) || !offer) {
    return null;
  }

  const { ends, header, sublist } = getContentForOffer(offer);
  const rewards = getAllRewards(offer);

  return (
    <Section variant="paddingBottomSpacer9">
      <Image src={offerTagImage.src} alt="Offer" />
      <H2 variant="marginBottomSpacer12" looksLike="h3">
        {/* @ts-expect-error - Automatic, Please fix when editing this file */}
        <OfferHeading offer={offer} placeholders={placeholders} rewards={rewards} header={header} />
      </H2>
      <RewardsList sublist={sublist} ends={ends} />
    </Section>
  );
};

export default HeroOfferSection;
